import { default_pods_input_state_smart_get, virtel_schema_smart_get } from "./ter-virtel-definition-lib";
import { _get_fixed_fields } from "./ter-virtel-utils";
import { _getParamsFromLib } from "./ter-params-utils";
import { protobomp_manipulator } from "../utils/frfr-protobomp-utils";
import { terProtobompUtils_make_protobomp_manifest_terkk_latest } from "./ter-protobomp-utils";


// TER DRAFTEL CODECS LIB

/*
protivkisnazaluzina u izradi

- 

TODO:
- 

*/


export const draftel_codecs_pack_terkk$_bundle_protivkisnazaluzina = {};


draftel_codecs_pack_terkk$_bundle_protivkisnazaluzina.default_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_protivkisnazaluzina',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    _subform_arr: [], // SUBFORM ARR

    _protobomp: protobomp_manipulator.init(terProtobompUtils_make_protobomp_manifest_terkk_latest("terkk$pkz"), null),

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default

    // pods_input za bundle nepotreban jer se koristi widget za pods_input

    //
    tip: "STANDARDNA",
    // TODO

    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_protivkisnazaluzina.default_pods_input_state = () => {
  /*
  return {

  };
  */
  return default_pods_input_state_smart_get('terkk$protivkisnazaluzina');
};


draftel_codecs_pack_terkk$_bundle_protivkisnazaluzina.default_subform_item_preset_state = () => {
  const preset_state = {
    _draftelschemakey: 'terkk$_bundle_protivkisnazaluzina_subform_item',
    terkknivo: 'CHILDOFMODUL', // ???
    // ID polje ne ide u preset, dobija se samo u EDIT MODE ali i tada mora biti obezbedjeno

    "flag_custom_pods_input": false, // flag_custom_pods_input is false by default


    kolicina: 1,
  };
  return preset_state;
};


draftel_codecs_pack_terkk$_bundle_protivkisnazaluzina.keys_for_direct_cloning = [
  "flag_custom_pods_input",

  // pods_input 

  ...Object.keys(draftel_codecs_pack_terkk$_bundle_protivkisnazaluzina.default_pods_input_state()),

  "rev_id",
  "superkey",
  "subkey",
  "parent_subkey",
  ...Object.keys(draftel_codecs_pack_terkk$_bundle_protivkisnazaluzina.default_subform_item_preset_state())
];


/////////


// ---------- CODEC ENCODING  - DRAFTEL TO VIRBOM DIRECTION ----------




// ---------- CODEC DECODING - VIRBOM TO DRAFTEL DIRECTION ----------
// ZA NOVE POLUPROIZVODE NECEMO NI KORISTITI DECODING

